export default __webpack_public_path__ + "static/media/less.d430b436.svg";